var FileType;
(function (FileType) {
  FileType["DIR"] = "DIR";
  FileType["TXT"] = "TXT";
  FileType["PDF"] = "PDF";
  FileType["DOC"] = "DOC";
  FileType["DOCX"] = "DOCX";
  FileType["XLS"] = "XLS";
  FileType["XLSM"] = "XLSM";
  FileType["XLSX"] = "XLSX";
  FileType["CSV"] = "CSV";
  FileType["MSG"] = "MSG";
  FileType["ZIP"] = "ZIP";
  FileType["RTF"] = "RTF";
  FileType["XML"] = "XML";
  FileType["DAT"] = "DAT";
  FileType["TSV"] = "TSV";
})(FileType || (FileType = {}));

export { FileType };
